module.exports = __webpack_public_path__ + "img/virtual-reality.5dbba330.svg";